<template>
    <div>
        <!-- <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Fees Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <a :href="path" style="color:yellow;" target="blank">
                 Payment Policy!!!
                        </a>
            </v-toolbar>
            <v-row justify="center"> 
                 <v-tooltip top color="warning">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn  color="red" outlined rounded small class="button" v-bind="attrs" v-on="on" @click="dialog_issue = true"> Amount deducted but receipt not generated. click here</v-btn>
                        </template>
                        <span>
                             Steps to raise dispute.
                        </span>
                    </v-tooltip>
                </v-row> 
            <!-- <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_ay" item-value="ay_id" :items="academic_year_list" item-text="academicyear" label="Select Academic Year" outlined 
                     @click="show = false" persistent-hint hint="Please Select Academic Year"
                    />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-combobox color="#0f2027" rounded v-model="selected_children" :items="children" label="Select Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle" @click="show = false"></v-combobox>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn class="button" @click="getDetails()">Proceed</v-btn>
                </v-col>
            </v-row> -->
            <span v-if="show == true">
                 <span v-if="learner_info!=null">
                    <div class="scroll">
                        <v-simple-table v-if="org_id != 'vvp'"  dense class="elevation-1" fixed-header>
                            <thead>
                                <tr>
                                    <th class="text-center">Name</th>
                                    <th class="text-center">Standard</th>
                                    <th class="text-center">Division</th>
                                    <th class="" v-for="header in ay_header" :key="header">
                                        <center>{{ header }}</center>
                                    </th>
                                    <th class="text-center">Total Outstanding</th>
                                    <th class="text-center">Paid Outstanding</th>
                                    <th class="text-center">Remaining Outstanding</th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <tr v-for="(s,index) in learner_info" :key="index">
                                    <td class="text-center">{{s.name}}</td>
                                    <td class="text-center">{{s.leaner_std}}</td>
                                    <td class="text-center">{{s.leaner_div}}</td>
                                    <td v-for="header in s.out_amt" :key="header" class="text-center">
                                        {{header}}
                                    </td>
                                    <td class="text-center"><strong>{{all_total_amount}}</strong></td>
                                    <td class="text-center"><strong>{{all_total_paid}}</strong></td>
                                    <td class="text-center"><strong>{{all_total_remaining}}</strong></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
             </span>
             <br>
                <v-row justify="center">
                    AY ::{{current_ay}} <v-divider color="grey" class="mx-2" vertical></v-divider> Standard :: {{leaner_std}} <v-divider color="grey" class="mx-2" vertical></v-divider> Division :: {{leaner_div}} 
                    </v-row>
                    <v-row justify="center" dense v-if="hasAnyDiscountApplicable">
                        <v-alert
                            type="info"
                            variant="tonal"
                            class="my-3 text-caption"
                            dense
                            >
                            <strong>Note:</strong> Discounts are applicable only on full payment.
                            If <strong>partial payment</strong> has been made, the discount will not be applied.
                        </v-alert>

                    </v-row>
                     <v-col cols="12" sm="12" md="12">
                        <v-simple-table dense class="elevation-1 mytable">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>  
                                            Academic Year
                                        </th>
                                        <th>
                                            Name
                                        </th>
                                        <th>
                                            Total Amount
                                        </th>
                                        <th v-if="hasAnyDiscountApplicable">
                                            Discount Type
                                        </th>
                                        <th  v-if="hasAnyDiscountApplicable">
                                            Discount Applied
                                        </th>
                                        <th  v-if="hasAnyDiscountApplicable">
                                            Discount Date
                                        </th>
                                         <th  v-if="hasAnyDiscountApplicable">
                                            Discount Amount
                                        </th>
                                        <th>
                                            Paid Amount
                                        </th>
                                        <th>
                                            Remaining Amount
                                        </th>
                                         <th>
                                           Fine
                                        </th>
                                        <th>
                                           Due Date
                                        </th>
                                        <th>
                                            Amount To Pay
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="org_id != 'vvp'">
                                    <tr v-for="item,index1 in outstanding_details_list" :key="index1">
                                        <td>{{ item.of_academicyear }}</td>
                                        <td><strong>{{ item.name }}</strong></td>
                                        <td>{{ item.fee }}</td>
                                        <td>{{ item.paid_fee }}</td>
                                        <td>{{ item.balnace_fee }}</td>
                                        <td>{{ item.fine }}</td>
                                        <td>{{ item.due_date }}</td>
                                        <td><strong>{{ item.balnace_fee }}</strong></td>
                                    </tr>
                                    <tr v-for="item1,index in installment_details_list" :key="index">
                                        <td>{{ item1.of_academicyear }}</td>
                                        <td><strong>{{ item1.name }}</strong></td>
                                        <td>{{ item1.fee }}</td>
                                        <td>{{ item1.paid_fee }}</td>
                                        <td>{{ item1.balnace_fee }}</td>
                                        <td>{{ item1.fine }}</td>
                                        <td>{{ item1.due_date }}</td>
                                        <td><strong>{{ item1.balnace_fee + item1.fine}}</strong></td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr v-for="item1,index in installment_details_list" :key="index">
                                        <td>{{ item1.of_academicyear }}</td>
                                        <td><strong>{{ item1.name }}</strong></td>
                                        <td>{{ item1.fee }}</td>
                                        <td  v-if="hasAnyDiscountApplicable">{{ item1.discount_type ? item1.discount_type : "--" }}</td>
                                        <td  v-if="hasAnyDiscountApplicable">{{ item1.discount_amount }}</td>
                                        <td  v-if="hasAnyDiscountApplicable">{{ item1.discount_date }}</td>
                                        <td  v-if="hasAnyDiscountApplicable">{{ item1.total_after_discount }}</td>
                                        <td>{{ item1.paid_fee }}</td>
                                        <td>{{ item1.balnace_fee }}</td>
                                        <td>{{ item1.fine }}</td>
                                        <td>{{ item1.due_date }}</td>
                                        <td><strong>{{ item1.balnace_fee + item1.fine}}</strong></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                
                  <v-row justify="center" v-if="installment_list.length > 0">
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            multiple
                            required
                            v-model="inst_id"
                            return-object
                            :items="installment_list"
                            item-text="name"
                            label="Select Installments"
                            outlined
                            persistent-hint
                            hint="Please Select installments"
                        />
                        <!-- {{inst_id}} -->
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn
                            class="button"
                            @click="
                getmatrix();
              "
                        >
                            Get Fee Details
                        </v-btn>
                    </v-col>
                </v-row>
                  <!-- <v-row justify="center">
                    <span v-for="(inst,index) in installment_list" :key="index">
                        <input type="hidden" :value="index + 1" />
                        <input type="radio" class="radiospace" v-model="inst_id" v-bind:value="inst" @change="getmatrix(); getstatus(index,inst.name)" />
                        {{inst.name}}
                    </span>
                </v-row> -->
                <v-row  v-if="matrix_list!=''">
                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table dense class="elevation-1 mytable">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>
                                            Fees Component
                                        </th>
                                        <th>
                                            Total Amount
                                        </th>
                                        <th>
                                            Paid Amount
                                        </th>
                                        <th>
                                            Remaining Amount
                                        </th>
                                        <th>
                                            Amount To Pay
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item,index in matrix_list" :key="index">
                                        <td>{{ item.feescomponentacademicyear }}</td>
                                        <td>{{ item.amount }}</td>
                                        <td>{{ item.paid_till_now }}</td>
                                        <td>{{ item.reamining }}</td>
                                        <td>{{ item.amount_pay }}</td>
                                    </tr>
                                    <tr class="toolbar noborder">
                                        <td class="noborder toolbar"></td>
                                        <td class="noborder toolbar"></td>
                                        <td class="noborder toolbar"></td>
                                        <td class="noborder toolbar"><span v-if="total_amount != 0">Fine :: {{fine}} </span></td>
                                        <td class="noborder toolbar">Total Amount To Pay :: {{total_amount}}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row v-if="matrix_list!=''" justify="center">
                    <v-col cols="12" sm="2" md="2">
                        <span class="text-color1">Total Fees :: {{fees_amount}}</span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <span class="text-color2">Paid Fees :: {{paid_amount}}</span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="total_amount != 0">
                        <span class="text-color">Fine :: {{fine}}</span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <span class="text-color">Remaining Fees :: {{total_amount}}</span>
                    </v-col>
                </v-row>
                   <span class="flash" v-if="matrix_list!='' && total_amount!=0"><strong><center>Please do not REFRESH or CLOSE ERP page at the time of transaction</center></strong></span>
                <v-row justify="center" v-if="matrix_list!=''">
                <v-btn class="button" :loading="pg_loader" v-if="total_amount!=0 && pgs.includes('Bill-Desk') " @click="proceed(pg_hidden.studid,total_amount,inst_id.name,matrix_pg_list)">Pay Online[Bill-Desk]</v-btn>
                <!-- <v-btn class="button" :loading="pg_loader" v-if="total_amount!=0" @click="proceed()">Pay Online[PayTM]</v-btn> -->
                <form :action="url" v-if="pg_hidden!=null && pgs.includes('PayTM')" @submit="payment" name="paytmform"  method="POST">
                    <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                    <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                    <input type="hidden" :value="pg_hidden.uid" name="uid" />
                    <input type="hidden" :value="pg_hidden.studid" name="studid" />
                    <input type="hidden" :value="pg_hidden.ay" name="ay"/>
                    <input type="hidden" :value="total_amount" name="fee_amount"/>
                    <input type="hidden" :value="inst_id.name" name="purpose"/>
                    <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data"/>
                    <input type="hidden" :value="pg_hidden.hash_val" name="hash_val"/>    
                    <v-btn class="button" :loading="pg_loader" v-if="total_amount!=0" type="submit">Pay Online [PayTM]</v-btn>
                </form>
                  <form :action="easebuzz_url" v-if="pg_hidden != null && pgs.includes('EaseBuzz')" @submit="payment"
                        name="paytmform" method="POST">
                        <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                        <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                        <input type="hidden" :value="pg_hidden.uid" name="uid" />
                        <input type="hidden" :value="pg_hidden.studid" name="studid" />
                        <input type="hidden" :value="pg_hidden.ay" name="ay" />
                        <input type="hidden" :value="total_amount" name="fee_amount" />
                        <input type="hidden" :value="inst_id.name" name="purpose" />
                        <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                        <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                        <v-btn class="button" :loading="pg_loader" v-if="total_amount != 0" type="submit">Pay Online
                            [EaseBuzz]</v-btn>
                    </form>
                    <form :action="razorpay_url" v-if="pg_hidden != null && pgs.includes('RAZORPAY')" @submit="payment"
                        name="paytmform" method="POST">
                        <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                        <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                        <input type="hidden" :value="pg_hidden.uid" name="uid" />
                        <input type="hidden" :value="pg_hidden.studid" name="studid" />
                        <input type="hidden" :value="pg_hidden.ay" name="ay" />
                        <input type="hidden" :value="total_amount" name="fee_amount" />
                        <input type="hidden" :value="inst_id.name" name="purpose" />
                        <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                        <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                        <input type="hidden" value="INSTALLMENT" name="payment_type" />
                        <v-btn class="button" :loading="pg_loader" v-if="total_amount != 0" type="submit">Pay Online
                            [RAZORPAY]</v-btn>
                    </form>
                 <a :href="path" target="blank" v-if="matrix_list!=''">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="pt-3" icon color="#0f2027"  v-bind="attrs" v-on="on"> <v-icon color="#0f2027">mdi-eye</v-icon></v-btn>
                                </template>
                                <span>
                                    Payment Policy!!!
                                </span>
                            </v-tooltip>
                        </a>
                 </v-row>
            </span>
        </v-card>
          <!-- <v-dialog v-model="dialog_outsatnding" fullscreen>
         <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Student Otstanding Fees
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_outsatnding=false"><v-icon> mdi-close </v-icon></v-btn>
                </v-toolbar>
                 <student-outstanding-fees  :selected_children="selected_children"></student-outstanding-fees>
                <v-row justify="center">
                    <v-btn class="button no-display" @click="dialog_outsatnding=false">Cancel</v-btn>
                </v-row>  
            </v-card>
        </v-dialog> -->
        <v-dialog v-model="dialog_issue"  persistent max-width="1500px">
         <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Raise Dispute
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_issue=false"><v-icon> mdi-close </v-icon></v-btn>
                </v-toolbar>
                <v-col cols="12" sm="12" md="`12">
                    <center>
                You can raise dispute, if amount is deducted from your bank, but receipt is not generated. <br>
                Click on "Proceed", which will redirect to Payment History Page where you can raise dispute for that transaction. <br>
                Refer below figure for the same.
                <img :src="history" width="100%" height="100%" alt="logo" />
                </center>
                </v-col>
                <v-row justify="center">
                    <v-btn class="button">
                    <router-link style="text-decoration: none;color:black" :to="{name: 'parent-fee-history' }" class="root">
                        Proceed
                    </router-link>
                    </v-btn>
                    <v-btn class="button no-display" @click="dialog_issue=false">Cancel</v-btn>
                </v-row>  
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
  // import StudentOutstandingFeeBillDesk from "../Parent/StudentOutstandingFeeBillDesk";
    export default {
       // name: "StudentOutstandingFeeBillDesk",
        // components: {
        //     "student-outstanding-fees":StudentOutstandingFeeBillDesk,
        // },
        data: () => ({
            child_info: null,
            children: [],
            selected_install: [],
            get_component_installmet_list: [],
            show: false,
            dialog_outsatnding:false,
            selected_children: "",
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
            search: "",
            s3url: "",
            leaner_std: null,
            leaner_div: null,
            installment_list: [],
            inst_id: null,
            matrix_list: "",
            total_amount: "",
            paid_amount: "",
            fees_amount: "",
            debit_card_charges: "",
            credit_card_charges: "",
            netbanking_card_charges: "",
            selected: [],
            selectAll: false,
            fine: "",
            display_flag: false,
            matrix_pg_list:null,
            pg_hidden:null,
            pg_loader:false,
            path:null,
            total_outstanding:null,
            paid_outstanding:null,
            remaining_outstanding:null,
            outstanding:null,
            installment_details_list:[],
            outstanding_details_list:[],
            academic_year_list:[],
            selected_ay:null,
            outstanding_allow_Fee:null,
             learner_info:null,
            ay_header:null,
            all_total_amount:null,
            all_total_paid:null,
            all_total_remaining:null,
            outstanding_remaining:null,
            dialog_issue:false,
            history:null,
            pgs:[],
            org_id:null,
            razorpay_url:null,
            easebuzz_url:null,
            discount_type: "",
        }),
        created(){
        // this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm"
         this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm"
         this.easebuzz_url=process.env.VUE_APP_API_URL + "/PaymentGatewayEaseBuzz/easebuzz"
         this.razorpay_url=process.env.VUE_APP_API_URL + "/PayementGatewayzRazorPay/razorPayInitiate"
    },
     computed: {
            hasAnyDiscountApplicable () {
                return this.installment_details_list.some(
                item => item.is_discount_applicable === true
                )
            },
        },
        methods: {
            payment(){
               var formData = new FormData(paytmform);
            //    console.log("formData")
            //    console.log(formData)
               this.pg_loader= false
            },
          
            getstatus(index, name) {
                // if (name != "Remaining") {
                //     if (index != 0) {
                //         this.display_flag = this.installment_list[index - 1].inst_flag;
                //     } else {
                //         this.display_flag = true;
                //     }
                // } else {
                //     this.display_flag = true;
                // }
            },
             payFees() {
                 //alert("alert in payfee")
                 //alert(this.returnURL)
                    bdPayment.initialize({
                        msg: this.checksumurl,
                        callbackUrl: this.returnURL,
                        options: {
                            enableChildWindowPosting: true,
                            enablePaymentRetry: true,
                            retry_attempt_count: 2,
                        },
                    });
                },
            proceed(studid,total_amount,inst_id,matrix_pg_list){
                const data = {
                    purpose  : inst_id.name,
                    json_pre_trans_data : matrix_pg_list,
                    fee_amount : total_amount,
                    studid : studid
                }
                axios
                .post("/AccountingAndFees/getOnlinePaymentInfoBillDesk", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.checksumurl = res.data.checksumurl;
                            this.returnURL = res.data.returnURL;
                            this.payFees()
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getmatrix() {
                //alert(this.inst_id)
                const formData = {
                    inst_id: this.inst_id,
                    child: this.selected_children,
                    ay: this.selected_ay
                };
                axios
                    .post("/AccountingAndFees/getmatrix_new_multiple", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.matrix_list = res.data.matrix_list;
                            this.total_amount = res.data.total_amount;
                            this.paid_amount = res.data.paid_amount;
                            this.fees_amount = res.data.fees_amount;
                            this.debit_card_charges = res.data.debit_card_charges;
                            this.credit_card_charges = res.data.credit_card_charges;
                            this.netbanking_card_charges = res.data.netbanking_card_charges;
                            this.fine = res.data.fine;
                            this.pg_hidden = res.data.pg_hidden
                            this.matrix_pg_list = JSON.stringify(this.pg_hidden.json_pre_trans_data)
                        }
                    })
                    .catch((error) => {
                         this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {});
            },
            getDetails() {
                const formData = {
                    child: this.selected_children,
                    ay: this.selected_ay
                };
                axios
                    .post("/AccountingAndFees/getPaymentInfo", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            
                            // if(res.data.flag_fee == "YES"){
                                    if(res.data.flag == "YES"){
                                        this.show = true;
                                        this.current_ay = res.data.current_ay;
                                        this.leaner_std = res.data.leaner_std;
                                        this.leaner_div = res.data.leaner_div;
                                        this.installment_list = res.data.installment_list;
                                        this.installment_details_list = res.data.installment_details_list
                                        this.outstanding_details_list = res.data.outstanding_details_list
                                        this.outstanding = res.data.outstanding
                                        this.outstanding_allow_Fee = res.data.outstanding_allow_Fee
                                        for (var i = 0; i < this.installment_details_list.length; i++) {
                                            if (this.installment_details_list[i].balnace_fee == 0) {
                                                var details_id = this.installment_details_list[i].id;
                                                for (var j = 0; j < this.installment_list.length; j++) {
                                                    if (this.installment_list[j].id === details_id) {
                                                        // Remove the matching object from installment_list
                                                        this.installment_list.splice(j, 1);
                                                        break; // Exit the loop after removing the matching object
                                                    }
                                                }
                                            }
                                        }
                                        // var remaining = { id: "null", name: "Remaining" };
                                        // this.installment_list.push(remaining);

                                        //added 18-04-22
                                        this.learner_info = res.data.learner_info
                                        this.ay_header = res.data.ay_header 
                                        this.all_total_amount = res.data.all_total_amount
                                        this.all_total_paid = res.data.all_total_paid
                                        this.all_total_remaining = res.data.all_total_remaining

                                        this.outstanding_remaining = res.data.outstanding_remaining
                                        this.pgs = res.data.pgs
                                    }
                                    else  if(res.data.flag == "NO"){
                                        this.showSnackbar("#b71c1c", res.data.snackbar);
                                    }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
             this.history = "https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/payment_history.jpeg"
            //alert("this.s3url::"+this.s3url)
            this.path = "https://vgespl-zeal.s3.ap-south-1.amazonaws.com/documents/Terms+and+Conditions+Gateway.pdf"
            this.org_id = localStorage.getItem("EPS-tenant");
            this.selected_ay = localStorage.getItem("setay");
            this.selected_children = localStorage.getItem("setreg_no");
            this.getDetails()
           
        },
    };
</script>

<style scoped>
    td,
    th {
        border: 1px solid #ccc;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .noborder {
        border: none;
    }
    .noborder:hover {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
    }
    .text-color {
        font-weight: bold;
        color: red;
    }
    .text-color2 {
        font-weight: bold;
        color: darkseagreen;
    }
    .text-color1 {
        font-weight: bold;
        color: darkblue;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .btn-grad {
        /* background-image: linear-gradient(to right, #abbaab 0%, #ffffff  51%, #abbaab  100%) */
    }
    .btn-grad {
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: black;
        box-shadow: 0 0 20px rgb(190, 187, 187);
        border-radius: 10px;
        display: block;
    }

    .btn-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: black;
        text-decoration: none;
    }
    .btn1-grad {
        background-image: linear-gradient(to right, #085078 0%, #85d8ce 51%, #085078 100%);
    }
    .btn1-grad {
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: white;
        box-shadow: 0 0 20px #eee;
        border-radius: 10px;
        display: block;
    }

    .btn1-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: #fff;
        text-decoration: none;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .span-mr {
        margin: 1rem !important;
        padding: 0px;
    }
.flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}
</style>
